<template>
  <v-container>
    <v-row align-content="center" justify="center" fill-height>
      <v-col class="text-center">
        <v-img class="pb-4 mb-2" height="75" src="@/assets/404.svg" />
        <h1>{{ $t('L_404_text') }}</h1>
        <h3 class="text-h3" v-html="$t('L_unfortunately_text', { home: home })" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';

const componentOptions: ComponentOptions = {
  name: 'NotFoundPage',
  data: () => ({
    listener: undefined,
  }),
  computed: {
    home() {
      return document.getElementById('base_href')?.dataset.href;
    },
  },
  methods: {
    position() {
      const top = document.documentElement.offsetHeight / 2 - this.$el.offsetHeight / 2;
      this.$el.style.paddingTop = `${top}px`;
    },
  },
  mounted() {
    this.position();
    this.listener = window.addEventListener('resize', this.position.bind(this));
  },
  beforeUnmount() {
    if (this.listener) {
      window.removeEventListener('resize', this.listener);
    }
  },
};

export default defineComponent(componentOptions);
</script>
